import service from '../../config/axios.config';

export const getObjectiveKPIsByObjective = ({
  objectiveId
}) =>
  service.get(
    `/objectives/${objectiveId}/kpis`
  );

export const createObjectiveKPI = ({
  kpi,
  objectiveId
}) =>
  service.post(
    `/objectives/${objectiveId}/kpis`,
    {
      kpi
    }
  );

export const updateObjectiveKPI = ({
  kpi,
  objectiveId
}) =>
  service.put(
    `/objectives/${objectiveId}/kpis`,
    {
      kpi
    }
  );

export const deleteObjectiveKPI = ({
  kpiId,
  objectiveId
}) =>
  service.delete(
    `/objectives/${objectiveId}/kpis/${kpiId}`
  );
